export const environment = {
  vueAppAPIOrchestrator: "https://localhost:3000",
  vueAppAPI: "https://localhost:3003",
  dropiAPI: "https://localhost:8000/api",
  whatsappCloud: "http://localhost:3004",
};
